import React, { Fragment } from 'react';
import { module } from 'angular';
import { once } from 'lodash';

import {
  overrideRegistrationQueue,
  ReactInjector,
  Overridable
} from '@spinnaker/core';

@Overridable('armoryHeader')
export class ArmoryHeader extends React.Component<{}, {}> {
  public render() {
    return (
      <Fragment />
    );
  }
}
export class ArmoryHeaderRenderer extends React.Component<{}, {}> {
  public state = {
    loaded: false
  }

  public render(): React.ReactElement<ArmoryHeaderRenderer> {
    return this.state.loaded && (<ArmoryHeader />);
  }

  public componentDidMount() {
    ReactInjector.$rootScope.$on('$stateChangeStart', once(() => {
      this.setState({ loaded: true })
    }))
  }
}

export const ARMORY_HEADER_MODULE = 'armory.header.v1'
module(ARMORY_HEADER_MODULE, [])
  .run(function () {
    overrideRegistrationQueue.register(ArmoryHeaderRenderer, 'spinnakerHeader')
  });
